import type { DepartureResponse } from "@services/departure/types";
import { FORM_FIELDS } from "../constants";
import type { RequestDepartureFormData } from "../schema/requestDepartureFormSchema";

const mapDepartureToFormData = (departure: DepartureResponse): RequestDepartureFormData => ({
  [FORM_FIELDS.FIRST_VISIT]: departure.isFirstVisit ? true : false,
  [FORM_FIELDS.MASTER_NAME]: departure.masterName ?? "",
  [FORM_FIELDS.NEXT_PORT]: departure.nextPort.portCode ?? "",
  [FORM_FIELDS.FINAL_DESTINATION]: departure.finalDestination?.portCode ?? "",
  [FORM_FIELDS.VESSEL_CONDITION]: departure.vesselCondition.conditionCode ?? "",
  [FORM_FIELDS.DRAFT_FORE]: departure.draftFore,
  [FORM_FIELDS.DRAFT_AFT]: departure.draftAft,
  [FORM_FIELDS.REQUEST_ANCHORAGE_CLEARANCE]: departure.requestAnchorageClearance,
  [FORM_FIELDS.PRE_SAILING_MASTER_DECLARATION]: [
    {
      name: departure.presailingMasterDeclarationDocumentName ?? "",
      url: departure.presailingMasterDeclarationDocumentUrl ?? "",
      type: "",
    },
  ],
  [FORM_FIELDS.DEPARTURE_CREW_LIST]: departure.crewListDocumentUrl
    ? [
        {
          name: departure.crewListDocumentName ?? "",
          url: departure.crewListDocumentUrl,
          type: "",
        },
      ]
    : undefined,
  [FORM_FIELDS.CARGO_MANIFEST]: [
    {
      name: departure.cargoManifestDocumentName ?? "",
      url: departure.cargoManifestDocumentUrl ?? "",
      type: "",
    },
  ],
  [FORM_FIELDS.CUSTOMS_CLEARANCE]: departure.clearanceDocumentUrl
    ? [
        {
          name: departure.clearanceDocumentName ?? "",
          url: departure.clearanceDocumentUrl ?? "",
          type: "",
        },
      ]
    : undefined,
  [FORM_FIELDS.CUSTOMS_CLEARANCE_UPLOAD_HAPPENED]: false,
  [FORM_FIELDS.REMARKS]: departure.remarks ?? "",
  [FORM_FIELDS.ADDITIONAL_DOCUMENTS]:
    departure.additionalDocuments?.map((document) => ({
      name: document.originalFileName ?? document.fileName ?? document.name ?? "",
      url: document.url ?? "",
      type: document.type ?? "",
      documentType: document.type ?? "",
      otherSpecifyType: document.specify ?? "",
      documentName: document.name ?? "",
      issueDate: document.issueDate ?? null,
      expiryDate: document.expiryDate ?? null,
      documentSummary: document.summary ?? "",
    })) ?? [],
});

export default mapDepartureToFormData;
